import { SelectChangeEvent } from "@mui/material";
import React from "react";
import { ErrorViewButtonConfig } from "../types/types";

interface IActivationFormContext {
  emailInputValue: string,
  emailInputChangeHandler: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  emailInputError: string | undefined,
  imeiInputValue: string,
  imeiInputChangeHandler: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  imeiInputError: string | undefined,
  selectValue: string,
  selectValueChangeHandler: (e: SelectChangeEvent<string>) => void,
  selectValueError: string | undefined,
  hearAboutUsValue: string,
  hearAboutUsChangeHandler: (e: SelectChangeEvent<string>) => void,
  hearAboutUsError: string | undefined,
  errorMessage: string | undefined,
  loading: boolean,
  formSubmitHandler: () => void,
  qrDecodeHandler: (imei: string) => void,
  errorButtonConfig: ErrorViewButtonConfig,
  errorEmail: string | undefined,
  errorTitle: string | undefined,
  disableSubmit: boolean,
}

const ActivationFormContext = React.createContext<IActivationFormContext>({
  emailInputValue: "",
  emailInputChangeHandler: () => {},
  emailInputError: undefined,
  imeiInputValue: "",
  imeiInputChangeHandler: () => {},
  imeiInputError: undefined,
  selectValue: "",
  selectValueError: undefined,
  selectValueChangeHandler: () => {},
  hearAboutUsValue: "",
  hearAboutUsChangeHandler: () => {},
  hearAboutUsError: undefined,
  errorMessage: undefined,
  loading: false,
  formSubmitHandler: () => {},
  qrDecodeHandler: () => {},
  errorButtonConfig: { showButton: false },
  errorEmail: undefined,
  errorTitle: undefined,
  disableSubmit: true,
});
export default ActivationFormContext;
